import { AnyAction, Dispatch } from "redux"

import { createSuccessNotification } from "../../notifications/actions/createSuccessNotification"

export const onPasswordResetSuccess = () => (dispatch: Dispatch<AnyAction>) => {
  dispatch(createSuccessNotification("Password reset succesfully"))
}
